var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont",class:`icon-${_vm.name}`,style:({fontSize: `${_vm.fontSize}px`, color: _vm.color, marginLeft: `${_vm.marginLeft}px`, marginRight: `${_vm.marginRight}px`, cursor: _vm.cursor ? 'pointer' : 'auto'})})
}
var staticRenderFns = []

export { render, staticRenderFns }